import type { CompetitorNearbyPlaceDto } from '@up2stay/up2promo-api-client';
import { Badge, cn } from '@up2stay/up2promo-ui';
import { BadgeCheck } from 'lucide-react';

import {
  COMPETITOR_RATING_EPSILON,
  formatPinRating,
} from '@/core/components/reputation/competitor-map-pins';
import {
  HEALTH_ATTENTION_CHIP_CLASS,
  HEALTH_OK_CHIP_CLASS,
  MetaChip,
  StarRating,
} from '@/core/components/reputation/reputation-bits';
import {
  formatVsYouChip,
  ratingDelta,
  type CompetitorTheaterLabels,
} from '@/core/components/reputation/competitor-theater-shared';

export function PlaceStats({
  place,
  labels,
  yourAverageRating,
}: {
  place: CompetitorNearbyPlaceDto;
  labels: CompetitorTheaterLabels;
  yourAverageRating?: number;
}) {
  const delta = ratingDelta(place.rating, yourAverageRating);
  return (
    <div className="flex flex-wrap items-center gap-3 text-sm">
      {place.rating != null ? (
        <span className="inline-flex items-center gap-1.5 font-medium">
          <StarRating rating={place.rating} />
          <span className="tabular-nums">{formatPinRating(place.rating)}</span>
        </span>
      ) : (
        <span className="text-muted-foreground">{labels.rating}: –</span>
      )}
      {place.reviewCount != null ? (
        <span className="text-muted-foreground tabular-nums">
          {place.reviewCount.toLocaleString()} {labels.reviews}
        </span>
      ) : null}
      {delta != null ? (
        <MetaChip
          className={cn(
            'tabular-nums',
            delta > COMPETITOR_RATING_EPSILON && HEALTH_ATTENTION_CHIP_CLASS,
            delta < -COMPETITOR_RATING_EPSILON && HEALTH_OK_CHIP_CLASS,
          )}
        >
          {formatVsYouChip(delta, labels)}
        </MetaChip>
      ) : null}
      {place.alreadyTracked ? (
        <Badge variant="info" className="gap-1">
          <BadgeCheck className="size-3.5" aria-hidden />
          {labels.tracked}
        </Badge>
      ) : null}
    </div>
  );
}
